import React, { memo, useCallback } from 'react';
import TalFigurative from './try-aibility/TalFigurative';
import TalContentRelated from './try-aibility/TalContentRelated';
import OcrGSDemonstration from './OcrGSDemonstration';
import OcrPtrDemonstration from './OcrPtrDemonstration';
import OcrCommonDemonstration from './OcrCommonDemonstration';
import VuLsdaDemonstration from './VuLsdaDemonstration';
import OcrSsaDemonstration from './OcrSsaDemonstration';
import CanvasFunctionDemonstration from './CanvasFunctionDemonstration';
import HandwritingRecognition from './HandwritingRecognition';
import VoiceFilesTranscription from './VoiceFilesTranscription';
import GeneralSpeechEvaluation from './GeneralSpeechEvaluation';
import RealTimeSpeechRecognition from './RealTimeSpeechRecognition';
import ExamPaperSplitRecord from '../solution/project-experience/ExamPaperSplitRecord';
import OcrBGDemonstration from './OcrBGDemonstration';
import CNCompositionCorrection from './CNCompositionCorrection';
import ENCompositionDemonstration from './ENCompositionDemonstration';
import ENCompositionCorrection from './ENCompositionCorrection';

const TalAbility = memo(({ production }) => {
  const showAibility = useCallback(() => {
    const {
      ability,
      materialsPath,
      selectList,
      initInfo,
      inputOption,
      materialsPathEn,
      materials
    } = production;
    switch (ability) {
      case 'TalFigurative':
        return <TalFigurative />;
      case 'TalContentRelated':
        return <TalContentRelated />;
      case 'OcrHrDemonstration':
        return (
          <HandwritingRecognition
            materialsPath={materialsPath}
            selectList={selectList}
            materialsPathEn={materialsPathEn}
          />
        );
      case 'OcrCCDemonstration':
        return (
          <CNCompositionCorrection
            materialsPath={materialsPath}
            selectList={selectList}
            inputOption={inputOption}
            initInfo={initInfo}
            materialsPathEn={materialsPathEn}
            lang={'cn'}
          />
        );
      case 'OcrECDemonstration':
        return (
          <>
            <ENCompositionCorrection
              materialsPath={materialsPath}
              selectList={selectList}
              inputOption={inputOption}
              initInfo={initInfo}
              materialsPathEn={materialsPathEn}
              lang={'en'}
            />
            <ENCompositionDemonstration />
          </>
        );
      case 'OcrPtrDemonstration':
        return (
          <OcrPtrDemonstration
            materialsPath={materialsPath}
            selectList={selectList}
          />
        );
      case 'OcrCommonDemonstration':
        return (
          <OcrCommonDemonstration
            materialsPath={materialsPath}
            selectList={selectList}
          />
        );
      case 'ExamPaperSplitRecord':
        return <ExamPaperSplitRecord contents={materialsPath} />;
      case 'VuLsdaDemonstration':
        return <VuLsdaDemonstration materialsPath={materialsPath} />;
      case 'OcrSsaDemonstration':
        return <OcrSsaDemonstration materialsPath={materialsPath} />;
      case 'OcrCanvasDemonstration':
        return (
          <CanvasFunctionDemonstration
            production={production}
            key={production.desc}
          />
        );
      case 'OcrGSDemonstration':
        return <OcrGSDemonstration materialsPath={materialsPath} />;
      case 'OcrBGDemonstration':
        return <OcrBGDemonstration materialsPath={materialsPath} />;
      case 'VoiceFilesTranscription':
        return <VoiceFilesTranscription materials={materials} />;
      case 'GeneralSpeechEvaluation':
        return <GeneralSpeechEvaluation abilityList={production.abilityList} />;
      case 'RealTimeSpeechRecognition':
        return (
          <RealTimeSpeechRecognition abilityList={production.abilityList} />
        );
      default:
        return <> </>;
    }
  }, [production]);
  return <>{showAibility(production)}</>;
});

export default TalAbility;
